var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errorMessage)?_c('p',[_vm._v("\n    "+_vm._s(_vm.errorMessage)),_c('br'),_vm._v("\n    Please try again later.\n  ")]):_vm._e(),(_vm.ticketSaleStartFromServer)?_c('p',[_vm._v("\n    Ticket sale starts at "+_vm._s(_vm.ticketSaleStartFromServer.toLocaleString())+".\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }